import { computed, signal } from "@preact/signals-react"

import { productDetailsEvolutionSelectedSku } from "./evolution"

export const productDetailsEvolutionTableAllData = signal({})
export const isLoadingProductDetailsEvolutionTable = signal(true)
export const productDetailsEvolutionTableDates = signal([])

// Computed
export const productDetailsEvolutionTableCurrentData = computed(() =>
	productDetailsEvolutionTableAllData.value[productDetailsEvolutionSelectedSku.value] || {}
)
